<template>
  <div id="how-to">
    <b-container class="container--max-lg">
      <div class="mb-3">
        <h1>How-To Guide</h1>
      </div>
      <div class="c-dashboard__card">
        <div class="mb-3">
          <router-link class="c-link" to="/dashboard">
            <svg viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.393 19.509L9.464 12l8.929-7.509a.5.5 0 0 0 .06-.704l-1.287-1.531a.5.5 0 0 0-.704-.06L6.168 10.851a1.5 1.5 0 0 0 0 2.296l10.294 8.657a.5.5 0 0 0 .704-.06l1.287-1.532a.5.5 0 0 0-.06-.704z"
                  id="ic-angle-left_svg__a"
                />
              </defs>
              <use fill="currentColor" xlink:href="#ic-angle-left_svg__a" transform="translate(-5 -2)" fill-rule="evenodd" />
            </svg>
            <span>{{ $t("lang.label_back") }}</span></router-link
          >
        </div>
      </div>

      You can see the available MTG Quantum-Safe applications <router-link :to="{ name: 'quantum-safe-apps' }">{{ $t("lang.info_quantumSafeApps_download_here") }} </router-link>
      .
    </b-container>
  </div>
</template>

<script>
export default {
  name: "HowToGuide"
};
</script>

<style scoped></style>
